// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2f1jP","form-field":"Form_form-field__3hl7_","checkbox":"Form_checkbox__1lUYF"};